export default __webpack_public_path__ + "5a53f3a.png";